import React from "react";

import { NewCard } from "./NewCard";
import { NewBankAccount } from "./NewBankAccount";

import "../../styles/collect-payment-page.scss";

export class PaymentMethod extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isNewMethod: false,
    };
  }

  render() {
    var method = this.props.isCreditCard ? (
      <NewCard
        iFrameRef={this.props.iFrameRef}
        onPANValidate={this.props.onPANValidate}
        onUpdate={(d) => this.props.onUpdate(d)}
        onTokenize={this.props.onTokenize}
        paymentform={(f) => this.props.paymentForm(f)}
      />
    ) : (
      <NewBankAccount
        iFrameRef={this.props.iFrameRef}
        onTokenize={this.props.onTokenize}
        onPANValidate={this.props.onPANValidate}
        paymentform={(f) => this.props.paymentForm(f)}
        onUpdate={(d) => this.props.onUpdate(d)}
      />
    );

    return (
      <div className="payment-method">
        <h3>
          {this.props.isCreditCard
            ? "Enter Credit Card or Debit Card info"
            : "Enter Bank Account Information"}
        </h3>
        {method}
      </div>
    );
  }
}
